/** Five lines of prompt, reserved up front so the card does not jump on first keystroke. */
export const TASK_PROMPT_MIN_HEIGHT = 105;
export const TASK_PROMPT_MAX_HEIGHT = 240;

/**
 * Grows the task composer to its content between those two heights, and hands
 * scrolling back to the textarea past the ceiling. Shared by the new-task modal
 * and the automation editor, which are the same composer pointed at a schedule.
 */
export function resizeTaskComposer(element: HTMLTextAreaElement | null) {
  if (!element) return;
  element.style.height = "auto";
  const height = Math.min(Math.max(element.scrollHeight, TASK_PROMPT_MIN_HEIGHT), TASK_PROMPT_MAX_HEIGHT);
  element.style.height = `${height}px`;
  element.style.overflowY = element.scrollHeight > TASK_PROMPT_MAX_HEIGHT ? "auto" : "hidden";
}
